var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Profissional",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarProfissionais.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Função",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarProfissionais.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.funcao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "funcao", $$v);
      },
      expression: "form.filters.funcao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }, {
      name: "only-number",
      rawName: "v-only-number"
    }],
    attrs: {
      "label": "CPF",
      "maxlength": "14",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarProfissionais.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "cpf", $$v);
      },
      expression: "form.filters.cpf"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "GRE",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.form.lists.listGres,
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.greId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "greId", $$v);
      },
      expression: "form.filters.greId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "lotacao",
      "label": "Lotação",
      "items": _vm.form.lists.listLotacoes,
      "item-text": 'local',
      "item-value": 'id',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.lotacaoId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "lotacaoId", $$v);
      },
      expression: "form.filters.lotacaoId"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarProfissionais();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterProfissional();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": 'Não há registros a serem exibidos.'
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(item.nome))])];
      }
    }, {
      key: `item.cpf`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(_vm.$formatCpf(item.cpf)))])];
      }
    }, {
      key: `item.funcao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('span', [_vm._v(_vm._s(item.funcao))])];
      }
    }, {
      key: `item.gre`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('span', [_vm._v(_vm._s(item.gre))])];
      }
    }, {
      key: `item.lotacao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('span', [_vm._v(_vm._s(item.lotacao))])];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarProfissional(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterProfissional(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarProfissional(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarProfissionalDialog', {
    attrs: {
      "visible": _vm.dialogManterProfissional.visible,
      "content": _vm.dialogManterProfissional.content,
      "edit": _vm.dialogManterProfissional.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterProfissional.close();
      },
      "onSave": function ($event) {
        return _vm.buscarProfissionais();
      }
    }
  }), _vm.dialogVisualizarProfissional.visible ? _c('VisualizarProfissionalDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarProfissional.visible,
      "content": _vm.dialogVisualizarProfissional.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarProfissional.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }